import $ from "jquery";

export default function initializeSponsorAccordion() {
    $('.sponsor-button').click(function() {
        if($(this).hasClass('sponsor-is-open') == false) {
            $(this).addClass('sponsor-is-open');
        } else {
            $(this).removeClass('sponsor-is-open');
        }
    });
}